import React, { useLayoutEffect, useRef, useState } from 'react';
import { formatMoney } from '../../../utils/money';

// The bar fixed at the bottom of the web form, as the app's footer (FormActions):
// what makes up the total, the total, and the step's buttons. The page scrolls
// behind it; the space it takes is kept at the end, so nothing stays under it.
const FormBottomBar = ({ lines = [], total = null, totalLabel = 'Total', status = null, children }) => {
  const barRef = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const bar = barRef.current;
    if (!bar) return undefined;
    const measure = () => setHeight(bar.offsetHeight);
    measure();
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(measure);
    observer.observe(bar);
    return () => observer.disconnect();
  }, []);

  const showsTotal = total !== null && total > 0.005;
  return (
    <>
      <div className="form-bottom-bar-spacer" style={{ height }} />
      <div className="form-bottom-bar" ref={barRef} role="region" aria-label="Total i botons">
        <div className="form-bottom-bar-content">
          {showsTotal ? (
            <div className="form-bottom-bar-summary">
              {lines.map((line) => (
                <div key={line.key} className="form-bottom-bar-line">
                  <span>{line.quantity > 1 ? `${line.quantity}× ` : ''}{line.label}</span>
                  <span>{formatMoney(line.amount)}€</span>
                </div>
              ))}
              <div className="form-bottom-bar-total">
                <span>{totalLabel}</span>
                <span>{formatMoney(total)}€</span>
              </div>
            </div>
          ) : null}
          {status ? <div className="form-bottom-bar-status">{status}</div> : null}
          {children}
        </div>
      </div>
    </>
  );
};

export default FormBottomBar;
